import * as yup from "yup";

export const validateEmailSchema = yup.object().shape({
  email: yup.string().email()
});
export function isValidEmail(email?: string | null) {
  return !!email && validateEmailSchema.isValidSync({ email });
}
